

/// <reference path="StockNoteProductLine.ts" />

// Generated class SupplierNoteLine_ManagedObject

class SupplierNoteLine_ManagedObject extends StockNoteProductLine
{
}
